
import { EExpand } from '@r1-frontend/api-domru/api-content/_dto/tariff-lines-common-types';

import { IRequest } from '@r1-frontend/shared/types/IRequest';

import { ResponseDto } from './dto/ResponseDto';

type TTariffLinesProperties = {
    restrictIgnore?: number,
    expand?: EExpand[],
    behavior?: string,
    fields?: string[],
    accessMode?: number,
}

const getTariffLines = ({ behavior, restrictIgnore, expand, fields, accessMode }: TTariffLinesProperties): IRequest => {
    const queryParams: {
        behavior?: string,
        restrictIgnore?: number,
        expand?: string,
        fields?: string,
        accessMode?: number,
    } = {};

    if (behavior) {
        queryParams.behavior = behavior;
    }

    if (restrictIgnore) {
        queryParams.restrictIgnore = restrictIgnore;
    }

    if (expand) {
        queryParams.expand = expand.join(', ');
    }

    if (fields) {
        queryParams.fields = fields.join(', ');
    }

    if (accessMode) {
        queryParams.accessMode = accessMode;
    }

    return {
        uri: '/v1/tariff-lines',
        method: 'GET',
        withProvider: true,
        queryParams,
    };
};

export default getTariffLines;

export type {
    ResponseDto,
};
